import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  Grid,
  Stack,
} from "@mui/material";
import WalletConnectProvider from "@walletconnect/web3-provider";
import WalletLink from "walletlink";

import Web3 from "web3";

import { httpRPCEndpoint, ChainId } from "../contracts/ContractProvider";

import ConnectedWeb3Provider from "../wallet/ConnectedWeb3Provider";

const walletLink = new WalletLink({
  appName: "Shiryo DApp",
  appLogoUrl: "https://app.shiryoinu.com/logo.png",
  darkMode: false,
});

const ConnectWalletModal = ({ walletModal, setWalletModal }) => {
  //const [open, setOpen] = React.useState(false);
  const [chainError, setChainError] = React.useState(false);

  const onMetamaskConnect = async () => {
    const web3I = new Web3(Web3.givenProvider);
    await web3I.eth.requestAccounts().catch(() => { });
    //props.close();
    setWalletModal(!walletModal);
  };

  const onWalletConnect = async () => {
    const wcProvider = new WalletConnectProvider({
      chainId: ChainId,
      rpc: {
        137: httpRPCEndpoint,
      },
    });

    wcProvider.on("unhandledRejection", (error) => {
      // Will print "unhandledRejection err is not defined"
      //console.log("unhandledRejection", error.message);
    });

    // Subscribe to accounts change
    wcProvider.on("accountsChanged", (accounts) => {
      //console.log(accounts);
      //console.log(wcProvider);
      const walletConnectWeb3 = new Web3(wcProvider);
      ConnectedWeb3Provider.web3 = walletConnectWeb3;
      ConnectedWeb3Provider.wallet = "WalletConnect";
    });

    // Subscribe to chainId change
    wcProvider.on("chainChanged", (chainId) => {
      //console.log(chainId);
    });

    // Subscribe to session disconnection
    wcProvider.on("disconnect", (code, reason) => {
      //console.log(code, reason);
      ConnectedWeb3Provider.web3 = null;
    });

    try {
      //console.log(wcProvider);

      const result = await wcProvider.enable().catch((err) => {
        //console.log(err);
        wcProvider.qrcodeModal.close();
      });
      // //console.log(bscProvider)
      if (wcProvider.chainId !== ChainId) {
        // wrong chain.
        setChainError(true);
        setWalletModal(!walletModal);
        wcProvider.disconnect();
      } else {
        // connected on correct chain

        // end of
        //props.close();
        setWalletModal(!walletModal);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onWalletLink = () => {
    const ethereum = walletLink.makeWeb3Provider(httpRPCEndpoint, 1);
    const walletLinkWeb3 = new Web3(ethereum);
    ConnectedWeb3Provider.web3 = walletLinkWeb3;
    ConnectedWeb3Provider.wallet = "WalletLink";
  };

  return (
    <Dialog onClose={() => setWalletModal(!walletModal)} open={walletModal}>
      <DialogTitle sx={{ textAlign: "center", p: 3, fontSize: "1rem" }}>
        Choose Wallet
      </DialogTitle>
      <DialogContent>
        <Stack sx={{ p: 3 }} spacing={3}>
          <Grid
            sx={{ cursor: "pointer" }}
            justifyContent="space-between"
            alignItems="center"
            container
            onClick={() => onMetamaskConnect()}
          >
            <Grid sx={{ pr: 3 }} item xs={4}>
              <img
                alt="Metamask"
                src={require(`./logos/metamask.svg`).default}
                height="32"
              />
            </Grid>
            <Grid item xs={8}>
              <Typography>Metamask</Typography>
            </Grid>
          </Grid>
          <Grid
            sx={{ cursor: "pointer" }}
            justifyContent="space-between"
            alignItems="center"
            container
            onClick={() => onWalletConnect()}
          >
            <Grid sx={{ pr: 3 }} item xs={4}>
              <img
                alt="WalletConnect"
                src={require(`./logos/walletconnect.svg`).default}
                height="32"
              />
            </Grid>
            <Grid item xs={8}>
              <Typography>Wallet Connect</Typography>
            </Grid>
          </Grid>
          <Grid
            sx={{ cursor: "pointer" }}
            justifyContent="space-between"
            alignItems="center"
            container
            onClick={() => onWalletLink()}
          >
            <Grid sx={{ pr: 3 }} item xs={4}>
              <img
                alt="WalletLink"
                src={require(`./logos/coinbase.png`).default}
                height="32"
              />
            </Grid>
            <Grid item xs={8}>
              <Typography>Coinbase</Typography>
            </Grid>
          </Grid>
          <Grid
            sx={{ cursor: "pointer" }}
            justifyContent="space-between"
            alignItems="center"
            container
            onClick={() => onMetamaskConnect()}
          >
            <Grid sx={{ pr: 3 }} item xs={4}>
              <img
                alt="Metamask"
                src={require(`./logos/TWT.svg`).default}
                height="32"
              />
            </Grid>
            <Grid item xs={8}>
              <Typography>Trust Wallet</Typography>
            </Grid>
          </Grid>
        </Stack>
      </DialogContent>
    </Dialog>
    // <div id="wallet-modal">
    //   <div className="title"></div>

    //   {chainError === true ? (
    //     <div>
    //       <div>WRONG NETWORK!</div>
    //       <div>First connect your wallet to BSC.</div>
    //     </div>
    //   ) : (
    //     <div>
    //       <div>
    //         <div onClick={() => onMetamaskConnect()} className="modal-row">
    //           <div>Metamask</div>

    //           <div>
    //             <img alt="Metamask" src={require(`./logos/metamask.svg`).default} height="40" />
    //           </div>
    //         </div>

    //         <div onClick={() => onMetamaskConnect()} className="modal-row">
    //           <div>Trust Wallet</div>
    //           <div>
    //             <div>
    //               <img alt="Trust Wallet" src={require(`./logos/TWT.svg`).default} height="40" />
    //             </div>
    //           </div>
    //         </div>
    //         {/*
    //         <div onClick={() => onWalletConnect()} className="modal-row">
    //           <div>WalletConnect</div>
    //           <div>
    //             <img
    //               alt="Metamask"
    //               src={require(`./logos/walletconnect.svg`).default}
    //               height="40"
    //             />
    //           </div>
    //         </div> */}
    //       </div>
    //     </div>
    //   )}
    // </div>
  );
};

export default ConnectWalletModal;
